import { defineComponent, renderSlot, provide } from 'vue';
import { LOCATION_CONTEXT } from '../api/keys';
import { Action } from 'history';
export const Router = defineComponent({
    name: 'Router',
    props: {
        location: { required: true, type: Object },
        navigator: { required: true, type: Object },
        action: {
            required: false,
            type: String,
            default: Action.Pop,
        },
        static: { required: false, type: Boolean, default: false },
    },
    setup(props, { slots }) {
        provide(LOCATION_CONTEXT, props);
        return () => renderSlot(slots, 'default');
    },
});
